var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('AlertMsg'),_c('Header',{attrs:{"scroll-over-hero":_vm.scrollOverHero},on:{"scroll":_vm.handleScroll}}),_c('router-view',{on:{"pass-hashero":_vm.handleGotop}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }